var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.32812 23.4372V1.55747L7.41987 0.949219C3.55812 2.49947 0.828125 6.27122 0.828125 10.6872V18.1872C0.828125 23.9862 5.52913 28.6872 11.3281 28.6872H18.8281C22.3696 28.6872 25.4904 26.9262 27.3909 24.239V23.4372H8.32812Z",
    fill: "#2962FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.8281 0.187256H11.3281C9.94438 0.187256 8.62738 0.461756 7.41763 0.947756C4.91788 3.37476 3.07812 7.33326 3.07812 10.6873C3.07812 15.7655 3.78012 18.7385 5.86212 21.6425C6.02412 21.8683 6.12988 22.1323 6.14413 22.409C6.17638 23.0353 6.04738 24.1828 4.91863 25.2155C4.79713 25.3265 4.87438 25.5298 5.03863 25.5365C5.74513 25.5673 7.17088 25.526 8.63638 24.8788C9.05413 24.6943 9.52962 24.7265 9.93312 24.941C12.4179 26.2603 15.3279 26.4373 18.0781 26.4373C21.5851 26.4373 25.0824 25.6573 27.3909 24.2503C28.6066 22.5365 29.3281 20.4478 29.3281 18.1873V10.6873C29.3281 4.88826 24.6271 0.187256 18.8281 0.187256Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 427318773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.6406 16.6873C23.0904 16.6873 21.8281 15.425 21.8281 13.8748C21.8281 12.3245 23.0904 11.0623 24.6406 11.0623C26.1909 11.0623 27.4531 12.3245 27.4531 13.8748C27.4531 15.425 26.1909 16.6873 24.6406 16.6873ZM24.6406 12.1873C23.7106 12.1873 22.9531 12.9448 22.9531 13.8748C22.9531 14.8048 23.7106 15.5623 24.6406 15.5623C25.5706 15.5623 26.3281 14.8048 26.3281 13.8748C26.3281 12.9448 25.5706 12.1873 24.6406 12.1873Z",
    fill: "#2962FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.7031 16.6873H19.9531C19.7461 16.6873 19.5781 16.5193 19.5781 16.3123V9.93726H20.7031V16.6873Z",
    fill: "#2962FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.3281 11.2498V11.639C16.8564 11.282 16.2759 11.0623 15.6406 11.0623C14.0904 11.0623 12.8281 12.3245 12.8281 13.8748C12.8281 15.425 14.0904 16.6873 15.6406 16.6873C16.2759 16.6873 16.8564 16.4675 17.3281 16.1105V16.3123C17.3281 16.5193 17.4961 16.6873 17.7031 16.6873H18.4531V11.2498H17.3281ZM15.6406 15.5623C14.7106 15.5623 13.9531 14.8048 13.9531 13.8748C13.9531 12.9448 14.7106 12.1873 15.6406 12.1873C16.5706 12.1873 17.3281 12.9448 17.3281 13.8748C17.3281 14.8048 16.5706 15.5623 15.6406 15.5623Z",
    fill: "#2962FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.0156 9.93726H7.01562V11.0623H11.0064L6.82812 15.9373H6.84763C6.72538 16.0955 6.64062 16.2845 6.64062 16.4998V16.6873H12.2656C12.4726 16.6873 12.6406 16.5193 12.6406 16.3123V15.5623H8.64987L12.8281 10.6873H12.8086C12.9309 10.529 13.0156 10.34 13.0156 10.1248V9.93726Z",
    fill: "#2962FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZalo);
export default __webpack_public_path__ + "static/media/zalo.a3b19a393d94eaa1eded2e21be558f2e.svg";
export { ForwardRef as ReactComponent };